import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SpacesMock } from "../../../components/Mockups/SpacesMock";

export const Spaces = () => {
  const { t } = useTranslation();
  return (
    <section id="spaces" className="container section-padding pb-0">
      <div className="row align-items-center">
        <div className="col-xl-6 col-lg-6 col-12 order-2 order-lg-1">
          <div className="bg-blue bg-opacity-10 p-3 p-md-4 rounded-4 justify-content-center flex-column d-flex">
            <SpacesMock />
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-12 order-1 order-lg-2">
          <div className="ms-0 ms-lg-4">
            <h3 className="mb-0 fw-bold fs-2 mb-4">
              {t("features.spaces.title")}
            </h3>
            <p className="mb-4">{t("features.spaces.description")}</p>
            <ul className="list-unstyled mb-0 d-flex flex-column gap-3 mb-4 mb-md-4 mb-lg-0">
              <li className="d-flex flex-row gap-2">
                <i className="bi bi-check-circle-fill text-success"></i>
                <span>{t("features.spaces.benefits.personal")}</span>
              </li>
              <li className="d-flex flex-row gap-2">
                <i className="bi bi-check-circle-fill text-success"></i>
                <span>{t("features.spaces.benefits.contextSpecific")}</span>
              </li>
              <li className="d-flex flex-row gap-2">
                <i className="bi bi-check-circle-fill text-success"></i>
                <span>{t("features.spaces.benefits.cleanSeparation")}</span>
              </li>
            </ul>
            <div className="mb-4 mb-lg-0 mt-4">
              <Link
                to="/features/spaces"
                className="btn btn-none p-0 text-blue d-inline-flex align-items-center gap-2"
              >
                {t("features.buttons.spaces")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
